import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AuthProvider from "./auth/AuthProvider";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage"; // Creamos este más tarde
import PremieresPage from "./pages/PremieresPage";
import LinksPage from "./pages/LinksPage";
import PrivateRoute from "./auth/PrivateRoute"; // Creamos este más tarde

// Importa los estilos de Bootstrap (asegúrate de tener bootstrap instalado)
import "bootstrap/dist/css/bootstrap.min.css";
// Importa los estilos de Bootstrap Icons
import "bootstrap-icons/font/bootstrap-icons.css";
// Importa estilos personalizados si los tienes o añadelos más tarde
import "./assets/scss/styles.scss"; // <-- Asegúrate de que la ruta y extensión son correctas
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
function App() {
  return (
    <Router>
      <AuthProvider>
        {" "}
        {/* Envuelve toda la aplicación con el proveedor de autenticación */}
        <Routes>
          {/* Rutas públicas */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Rutas protegidas (requieren autenticación) */}
          {/* Usaremos un componente PrivateRoute para esto */}
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<DashboardPage />} />{" "}
            {/* Ruta raíz es el dashboard protegido */}
            <Route path="/premieres" element={<PremieresPage type="tv" />} />
            <Route path="/premieres/movies" element={<PremieresPage type="movie" />} />
            <Route path="/links" element={<LinksPage />} />
            {/* Otras rutas protegidas irían aquí */}
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
